'use client';

import React, { ReactNode, memo } from 'react';

import { RadioButton, RadioContainer, RadioText } from './styled';

export type RadioProps = {
  value: string;
  name?: string;
  onChange?: (e: any) => void;
  label: ReactNode;
  checked?: boolean;
  kocAilemStyle?: boolean;
  disabled?: boolean;
  booker?: boolean;
  segment?: boolean;
};

const Radio = ({
  value,
  name,
  onChange,
  label,
  checked,
  disabled,
  booker,
  segment,
}: RadioProps) => {
  return (
    <RadioContainer segment={segment} disabled={disabled}>
      <RadioText segment={segment} booker={booker} disabled={disabled}>
        <RadioButton
          type='radio'
          value={value}
          checked={checked}
          onChange={onChange}
          name={name}
          disabled={disabled}
        />

        <span>{label}</span>
      </RadioText>
    </RadioContainer>
  );
};

export default memo(Radio);
